import { request } from '@/api/http'
import type { WorkbenchStage } from '@/lib/workbenchConfig'

export interface WorkstationConfigResponse {
  project_id: string
  ws_type: WorkbenchStage
  chapter_id: string | null
  config_json: unknown
}

export interface PutWorkstationConfigRequest {
  ws_type: WorkbenchStage
  chapter_id?: string
  config_json: unknown
}

export interface WorkstationOptionsResponse {
  screenplay: {
    style_presets: string[]
    length_options: string[]
    dialogue_density_options: string[]
    pov_options: string[]
  }
  storyboard: {
    shot_density_options: string[]
    preferred_shot_types: string[]
    camera_languages: string[]
    style_locks: string[]
  }
  panel_image: {
    models: string[]
    size_presets: string[]
    style_presets: string[]
  }
}

function configPath(projectId: string, suffix = '') {
  return `/v1/projects/${encodeURIComponent(projectId)}/workstation-config${suffix}`
}

function scopedConfigQuery(wsType: WorkbenchStage, chapterId?: string) {
  const qs = new URLSearchParams({ ws_type: wsType })
  if (chapterId) qs.set('chapter_id', chapterId)
  return qs.toString()
}

export const workbenchApi = {
  getConfig: (projectId: string, wsType: WorkbenchStage, chapterId?: string): Promise<WorkstationConfigResponse> =>
    request<WorkstationConfigResponse>(`${configPath(projectId)}?${scopedConfigQuery(wsType, chapterId)}`),

  getResolvedConfig: (projectId: string, wsType: WorkbenchStage, chapterId: string): Promise<WorkstationConfigResponse> =>
    request<WorkstationConfigResponse>(`${configPath(projectId, '/resolved')}?${scopedConfigQuery(wsType, chapterId)}`),

  getOptions: (projectId: string): Promise<WorkstationOptionsResponse> =>
    request<WorkstationOptionsResponse>(configPath(projectId, '/options')),

  putConfig: (projectId: string, body: PutWorkstationConfigRequest): Promise<WorkstationConfigResponse> =>
    request<WorkstationConfigResponse>(configPath(projectId), { method: 'PUT', body }),
}
